import React from "react";
import "./PublicClinicHeader.css";

/**
 * Clinic identity header shared by every patient-facing public page
 * (confirm / sign / questionnaire). Shows the clinic logo (or the clinic's
 * initial when no logo was uploaded), the clinic name and a short context
 * line telling the patient what this page is for.
 *
 * Presentation only — the clinic object comes from the page's public Cloud
 * Function payload ({ name, logoUrl }). Renders nothing when no clinic was
 * returned (legacy links / failed lookups) so pages never show an empty hero.
 *
 * `compact` → single row (used on success / review screens).
 */
const PublicClinicHeader = ({ clinic, eyebrow = "", compact = false }) => {
  const name = (clinic?.name || "").trim();
  const logoUrl = clinic?.logoUrl || null;

  if (!name && !logoUrl) return null;

  const initial = name ? name.charAt(0) : "";

  return (
    <div className={`pub-hero${compact ? " pub-hero--compact" : ""}`}>
      {logoUrl ? (
        <img src={logoUrl} alt={name || ""} className="pub-hero-logo" />
      ) : (
        <div className="pub-hero-logo pub-hero-logo--initial" aria-hidden="true">
          {initial}
        </div>
      )}
      <div className="pub-hero-text">
        {name && <h1 className="pub-hero-name">{name}</h1>}
        {eyebrow && <span className="pub-hero-eyebrow">{eyebrow}</span>}
      </div>
    </div>
  );
};

export default PublicClinicHeader;
